import React, { useEffect } from 'react'
import { useTranslate } from './TranslationText'
import { whiteCard } from '../common/cssclasses';
import { getOrdinal } from '../helper/getOrdinal';
import { useDispatch, useSelector } from 'react-redux';
import { subscribeToHorseOnAir, subscribeToTempRank } from '../Redux/FireStore/collectionThunks';
import { clearItems, clearItemsOnAir } from '../Redux/FireStore/collectionSlice';

export default function TempRanking({ showId, isFirebaseEnabled = false }) {
    const { translate } = useTranslate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!isFirebaseEnabled || !showId) {
            dispatch(clearItemsOnAir());
            dispatch(clearItems());
            return;
        }

        const unsubscribe = dispatch(subscribeToTempRank(showId));
        const onAirUnSub = dispatch(subscribeToHorseOnAir(showId));
        return () => {
            if (onAirUnSub) {
                onAirUnSub();
            }
            dispatch(clearItemsOnAir());
            if (unsubscribe) {
                unsubscribe();
            }
            dispatch(clearItems());
        };
    }, [dispatch, showId, isFirebaseEnabled]);

    // Use the real-time data from the store in this component
    const { data, loading, error } = useSelector(state => state.showTemporaryRank);
    
    const { inArenaHorseId, viewHorseBox,inArenaHorse } = useSelector(state => state.horseOnAir);

    const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';

    return (
        data?.length > 0 &&
        <div className="col-xl-4 col-lg-4 col-md-12 mb-main ">
            <div className={whiteCard} style={{maxHeight:750 , overflowY:"auto"}}>
                <h4 className='bold' >{currentLanguage == 'en' ? data?.at(-1)?.ClassName : data?.at(-1)?.ClassNameAr}</h4>
                <div className='d-flex justify-content-between'>
                    <h5 className='bold' >{translate('web.temporaryRank', 'Temporary Rank')}</h5>
                    <h6 className='bold' >{data?.at(-1)?.RankScoringList?.length} <i className="fa-solid fa-horse-head ms-2"></i></h6>
                </div>
                <table className="table tablenominwidth table-striped table-bordered rtl horseResultTable" style={{ direction: currentLanguage == "ar" ? "rtl" : "ltr", width: '100%', minWidth: 0 }}>
                    <thead className='text-center bg-danger'
                        style={{
                            color: "white",
                        }}
                    >
                        <th>
                            {translate("web.rank", "Rank")}
                        </th>
                        <th className='text-start' style={{padding:'.5rem'}}>{translate("web.horseName", "Horse Name")}</th>
                        <th>{translate("web.totalPoints", "Total Points")}</th>
                    </thead>
                    <tbody className='text-center'>
                        {data?.at(-1)?.RankScoringList?.map((x) => (
                            <tr >
                                {!!x?.HorseRank ?
                                    <td className='bold' dangerouslySetInnerHTML={{ __html: getOrdinal(x?.HorseRank) }} /> :
                                    <td className='bold' dangerouslySetInnerHTML={{ __html: "-" }} />
                                }
                                <td className='bold text-start'>
                                    {x?.HorseNumber} - {currentLanguage == 'en' ? x?.HorseName : x?.HorseNameAr}
                                </td>
                                {(inArenaHorseId?.toLowerCase() === x?.HorseId?.toLowerCase() && !!inArenaHorse?.HorseInArenaName  &&  (x?.TotalScore <= 0 || !x?.TotalScore)) ? <><td className='bold' > <span className='p-2 rounded ' > <i className='fa fa-circle red  w-unset' ></i>  {translate('web.liveHorse', 'Live')}</span></td></> :
                                    <td className='bold' >{x?.TotalScore != 0 && x?.TotalScore?.toFixed(2) } {!!x?.Reason && x.Reason} </td>
                                }
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

        </div>
    )
}
